import { ChargeConstants } from 'features/Charge/chargeHelper';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

AdminDashboardRoute.propTypes = {};

function AdminDashboardRoute(props) {
  // MARK: --- PROPERTIES ---
  const { user } = useSelector((state) => state.auth);
  const isAdmin =
    user?.role === ChargeConstants.UserRole.ADMIN ||
    user?.role === ChargeConstants.UserRole.OPERATOR ||
    user?.role === ChargeConstants.UserRole.MAINTAINER ||
    user?.role === ChargeConstants.UserRole.AGENCY && !user?.agency?.parentAgencyId;

  return isAdmin ? props.children : <Navigate to="/" />;
}

export default AdminDashboardRoute;
